import React from "react";
//#region types
import { GrossSalaryChangeContextState, ReApproveContextState } from "models/propTypes/wintSalaryPropTypes";
//#endregion

export const initialState: GrossSalaryChangeContextState = {
  personData: undefined,
  loading: false,
  companyResult: {},
  fetchInitialData: async () => {},
  refetchWithCalculation: async (grossSalary: number, useOneTimeTax?: boolean) => {},
  isTaxTypeSelectionEnabled: (grossSalary?: number) => false,
  minimumTargetGrossSalaryAmount: {
    monthlySalaryAmount: 0,
    taxTableMinimumAmount: 0,
    oneTimeTaxMinimumAmount: 0,
    alreadyPaidOutNetAmount: 0,
  },
};

export const GrossSalaryChangeContext = React.createContext<GrossSalaryChangeContextState>(initialState);

export const reApproveInitialState: ReApproveContextState = {
  personData: undefined,
  loading: false,
  fetchPersonReportData: async () => {},
  monthlySalary: undefined,
  socialFees: undefined,
  privateTax: undefined,
  netSalary: undefined,
};

export const ReApproveContext = React.createContext<ReApproveContextState>(reApproveInitialState);
